import { useQuery } from '@tanstack/react-query';
import { Spin } from 'antd';
import { MyCalendar, MyModal } from 'components';
import dayjs from 'dayjs';
import { IKeys, IWork } from 'models';
import { useState } from 'react';
import { SlotInfo } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useNavigate } from 'react-router-dom';
import { MY_WORKS_ROUTE } from 'routes/consts';
import { workService } from 'services';
import { userStore } from 'stores';

export const Schedule = () => {
	const navigate = useNavigate();
	const [work, setWork] = useState<IWork | null>(null);
	const [slot, setSlot] = useState<SlotInfo | null>(null);
	const [range, setRange] = useState({
		startd: dayjs().startOf('month').format('YYYYMMDD'),
		endd: dayjs().endOf('month').format('YYYYMMDD')
	});

	const { data, isLoading, refetch } = useQuery({
		queryKey: [IKeys.WORKS, { range }],
		queryFn: () => workService.getAll({
			per_page: 200,
			notpending: true,
			foreman: userStore.isForeman ? userStore.data?.id : undefined,
			...range
		})
	});

	const onRangeChange = (date: Date[] | { start: Date; end: Date }) => {
		if (!Array.isArray(date)) {
			setRange({
				startd: dayjs(date.start).format('YYYYMMDD'),
				endd: dayjs(date.end).format('YYYYMMDD')
			});
		} else {
			setRange({
				startd: dayjs(date[0]).format('YYYYMMDD'),
				endd: dayjs(date[date.length - 1]).format('YYYYMMDD')
			});
		}
	};

	const handleCancel = () => {
		setWork(null);
		setSlot(null);
	};

	const handleEvent = (value: IWork) => {
		if(userStore.isForeman) {
			navigate(`${MY_WORKS_ROUTE}/${value.id}`);
		} else {
			setWork(value);
		}
	};

	return (
		<Spin spinning={isLoading}>
			<MyCalendar
				data={data?.data || []}
				setWork={handleEvent}
				setSlot={setSlot}
				onRangeChange={onRangeChange}
			/>
			<MyModal
				work={work}
				slot={slot}
				handleCancel={handleCancel}
				queryKey={[IKeys.WORKS, { range }]}
				refetch={refetch}
			/>
		</Spin>
	);
};

